import { getData, postData } from "@/api/index";
// import { * } from "@/services/server/AccountInterface";

export async function getACPageAction(params) {
  return await getData("UserController/pageAction", params);
}

export async function postACInitPasswordAction(params) {
  return await postData("UserController/initPasswordAction", params);
}

export async function delACDelSonAccountAction(params) {
  return await getData("UserController/delSonAccountAction", params);
}

export async function getACAdminRoleAction() {
  return await getData("RoleController/adminRoleAction");
}

export async function postACAddSonAccountAction(params) {
  return await postData("UserController/addSonAccountAction", params);
}

export async function postACUpdateAction(params) {
  return await postData("UserController/updateAction", params);
}

export async function postACMenuUpdateAction(params) {
  return await postData("rbac.UserMenuController/updateAction", params);
}

export async function getACTableListTwoAction() {
  return await getData("rbac.UserMenuController/tableListTwoAction");
}

export async function getACFindOneAction(params) {
  return await getData("rbac.UserMenuController/findOneAction", params);
}

export async function getACAFFindOneAction(params) {
  return await getData("tool.AliCloudFaceController/findOneAction", params);
}

export async function getACDlsUpdateMoreAction(params) {
  return await getData("UserController/dlsUpdateMoreAction", params);
}

export async function getACDlsUpdateAction(params) {
  return await getData("UserController/dlsUpdateAction", params);
}

export async function getACUpdateMoreAction(params) {
  return await getData("call.CallSmartUserController/updateMoreAction", params);
}

export async function getACCallTableListAction(id) {
  return await getData(
    "call.CallSmartController/tableListAction?call_type_id=" + id
  );
}

export async function postACCallupdateAction(params) {
  return await postData("call.CallSmartUserController/updateAction", params);
}

export async function postACCompanyTypeUpdateAction(params) {
  return await postData("company.CompanyTypeController/updateAction", params);
}

export async function postACCompanyTypeAddAction(params) {
  return await postData("company.CompanyTypeController/addAction", params);
}

export async function getACCompanyTypeDelAction(params) {
  return await getData("company.CompanyTypeController/delAction", params);
}

export async function getACCompanyTypePageAction(params) {
  return await getData("company.CompanyTypeController/pageAction", params);
}

export async function postACCompanyUpdateAction(params) {
  return await postData("company.CompanyController/updateAction", params);
}

export async function postACCompanyAddAction(params) {
  return await postData("company.CompanyController/addAction", params);
}

export async function getACCompanyPageAction(params) {
  return await getData("company.CompanyController/pageAction", params);
}

export async function getACCompanyDelAction(params) {
  return await getData("company.CompanyController/delAction", params);
}

export async function getACCallListAction() {
  return await getData("call.CallSeatController/listAction");
}

export async function getACCallSeataddAction(params) {
  return await getData("call.CallSeatController/addAction", params);
}

export async function getACCallSetAgentAction(params) {
  return await getData("call.CallSeatController/setAgentAction", params);
}

export async function getACCallSeatPageAction(params) {
  return await getData("call.CallSeatLogController/pageAction", params);
}

export async function getACCallSeatBillPageAction(params) {
  return await getData("call.CallSeatBillController/pageAction", params);
}
export async function postDisabledUserAction(params) {
  return await postData("UserController/disabledUserAction", params);
}
export async function postCompanyBatchUpdateAction(params) {
  return await postData("company.CompanyController/BatchUpdateAction", params);
}
export async function postCompanyBatchUpdateBlackAction(params) {
  return await postData("company.CompanyController/BatchUpdateBlackAction", params);
}
export async function getCheckBalanceAction(params) {
  return await getData("UserController/CheckBalanceAction", params);
}
